import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HeartHandshake } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const { exchangeSession } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const search = window.location.search || "";
    const match = (search + "&" + hash).match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        await exchangeSession(sessionId);
        navigate("/", { replace: true });
      } catch (e) {
        setError("Sign-in failed. Please try again.");
        setTimeout(() => navigate("/", { replace: true }), 1600);
      }
    })();
  }, [exchangeSession, navigate]);

  return (
    <div className="min-h-screen grid place-items-center bg-surface">
      <div className="flex flex-col items-center gap-4">
        <div className="w-16 h-16 rounded-pill grid place-items-center text-white animate-float" style={{ background: "linear-gradient(135deg,#1E40AF,#5B21B6)" }}>
          <HeartHandshake size={34} strokeWidth={2.4} />
        </div>
        <div className="font-black text-lg">{error || "Signing you in…"}</div>
      </div>
    </div>
  );
}
